import axios from 'axios';
import axiosRetry from 'axios-retry';
import get from 'lodash/get';
import isFinite from 'lodash/isFinite';

import request from './request';

export function isRetriableError(statusCode) {
  return (
    statusCode !== 0 &&
    (statusCode === 429 || (statusCode >= 500 && statusCode <= 599))
  );
}

/**
 * Specify the delay until the next response. If the response is rate limited,
 * and the header Retry-After is present, give precedence to that value.
 * If not, we use a custom array of intervals where delay is set based on retry number.
 */
const retryIntervals = [[50, 60000], [20, 30000], [5, 10000], [0, 2000]];
export function retryDelay(retryNumber = 0, error = {}) {
  // Honor Retry-After response header for 429 responses
  if (get(error, 'response.status') === 429) {
    const retryAfter = parseInt(error.response.headers['retry-after'], 10);
    if (isFinite(retryAfter)) {
      // Retry-After header response is in seconds
      return retryAfter * 1000;
    }
  }

  for (const interval of retryIntervals) {
    const [retries, delay] = interval;
    if (retryNumber >= retries) return delay;
  }

  // Default to 2 seconds interval just to be safe.
  return 2000;
}

/**
 * Retry a network request until it succeeds or fails.
 */
export default function retriableRequest(options) {
  axiosRetry(axios, {
    retries: get(options, 'retries', 1),
    retryDelay,
    // Retry if it's a 5XX error or we hit the rate limit
    // on an idempotent request (GET, HEAD, OPTIONS, PUT or DELETE).
    retryCondition(error) {
      return isRetriableError(get(error, 'response.status'));
    },
  });

  return request(options);
}
